import type { TranslationFunction } from '../types';

const defaultTitle = ({
  sectionType,
  t,
}: {
  sectionType: string;
  t: TranslationFunction;
}) => {
  switch (sectionType) {
    case 'ReportSummarySection':
      return t('report_summary_section_title');
    case 'ReportSummaryKeyMetrics':
      return t('report_summary_key_metrics_title');
    case 'ReportVisibilitySection':
      return t('report_visibility_section_title');
    case 'ReportVisibilityOverview':
      return t('report_visibility_overview_title');
    case 'ReportVisibilityMentionsOverTime':
      return t('report_visibility_mentions_over_time_title');
    case 'ReportVisibilityReachOverTime':
      return t('report_visibility_reach_over_time_title');
    case 'ReportVisibilityHighlights':
      return t('report_visibility_highlights_title');
    case 'ReportVisibilityBenchmarkSection':
      return t('report_visibility_benchmark_section_title');
    case 'ReportVisibilityBenchmarkShareOfVoice':
      return t('report_visibility_benchmark_share_of_voice_title');
    case 'ReportVisibilityBenchmarkShareOfVoiceOverTime':
      return t('report_visibility_benchmark_share_of_voice_over_time_title');
    case 'ReportPerceptionSection':
      return t('report_perception_section_title');
    case 'ReportPerceptionSentimentOverview':
      return t('report_perception_sentiment_overview_title');
    case 'ReportPerceptionSentimentOverTime':
      return t('report_perception_sentiment_over_time_title');
    case 'ReportPerceptionBenchmarkSection':
      return t('report_perception_benchmark_section_title');
    case 'ReportPerceptionBenchmarkSentimentOverview':
      return t('report_perception_benchmark_sentiment_overview_title');
    case 'ReportMetricsSection':
      return t('reports_metrics');
  }
  return '';
};

export const getDefaultSectionTitle = ({
  section,
  t,
}: {
  section: { __typename: string; title?: string | null };
  t: TranslationFunction;
}): string => {
  return section.title === null
    ? defaultTitle({
        sectionType: section.__typename,
        t,
      })
    : (section.title ?? '');
};
